import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { resources, defaultLocale, resolveLocale, supportedLocales } from '@asia/i18n';

export const LANG_KEY = 'asia_lang';

// A user-chosen language (Profile → Language) wins; otherwise the device
// language drives the initial locale (English is the primary fallback). Inside
// Telegram we read languageCode from initDataUnsafe.
const stored = (() => {
  try {
    const v = localStorage.getItem(LANG_KEY);
    return v && (supportedLocales as string[]).includes(v) ? v : null;
  } catch {
    return null;
  }
})();
const deviceLang =
  window.Telegram?.WebApp?.initDataUnsafe?.user?.language_code ?? navigator.language;

void i18n.use(initReactI18next).init({
  resources,
  lng: stored ?? resolveLocale(deviceLang),
  fallbackLng: defaultLocale,
  interpolation: { escapeValue: false },
});

/** Change the app language and persist the choice across launches. */
export function setLanguage(code: string) {
  void i18n.changeLanguage(code);
  try {
    localStorage.setItem(LANG_KEY, code);
  } catch {
    /* storage unavailable */
  }
}

/** Apply the server-saved language (source of truth after /me loads). */
export function applyUserLanguage(code: string | null | undefined) {
  if (!code) return;
  const lang = (supportedLocales as string[]).includes(code) ? code : defaultLocale;
  if (i18n.language !== lang) void i18n.changeLanguage(lang);
  try {
    localStorage.setItem(LANG_KEY, lang);
  } catch {
    /* storage unavailable */
  }
}

export default i18n;
